import { DefaultAutocompleteDefinitions } from "widgets/WidgetUtils";

export const autocompleteConfig = {
  isVisible: DefaultAutocompleteDefinitions.isVisible,
};
